const AccountList = () => import('Views/account/account-list');
const AccountAddEdit = () => import('Views/account/account-addEdit');
const AccountDetail = () => import('Views/account/account-detail');
const AccountSetting = () => import('Views/account/account-setting');
const AccountWx = () => import('Views/account/account-wx');

export default[
  { path: '/account-list', component: AccountList },
  { path: '/account-add', component: AccountAddEdit },
  { path: '/account-setting', component: AccountSetting },
  { path: '/account-edit/:id', component: AccountAddEdit },
  { path: '/account-detail/:id', component: AccountDetail },
  { path: '/account-wx/:id', component: AccountWx },
];



// WEBPACK FOOTER //
// ./src/router/account.js